import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Add from '@mui/icons-material/Add';
import Close from '@mui/icons-material/Close';
import { FieldError } from '@/ui';
import NativeSelectField from '../FormFields/NativeSelectField';
import { Field, FieldArray } from 'redux-form';
import InternalSuppressionItem from './InternalSuppressionItem';

const renderAndOr = ({ input, type, meta }) => {
  return (
    <>
      <NativeSelectField {...input} type={type} error={Boolean(meta.error && meta.touched)}>
        <option value='AND'>All entries must pass</option>
        <option value='OR'>Any of these entries can pass</option>
      </NativeSelectField>
      <FieldError error={meta.error} touched={meta.touched} />
    </>
  );
};

const renderInternalPrePings = ({ fields, criteriaType, offers, offerActions, loadingOffers, offerActionsLoading }) => {
  useEffect(() => {
    if (fields.length === 0) {
      fields.push({});
    }
  }, [fields]);

  return (
    <div>
      {fields.map((fieldName, index) => (
        <div key={index}>
          <Card>
            <CardHeader
              title={
                fields.length > 1 ? (
                  <Tooltip title='Remove Internal Pre Ping'>
                    <IconButton
                      color='error'
                      type='button'
                      aria-label='Remove Internal Pre Ping'
                      onClick={() => fields.remove(index)}
                    >
                      <Close fontSize='small' />
                    </IconButton>
                  </Tooltip>
                ) : null
              }
              slotProps={{ title: { component: 'div' } }}
            />
            <CardContent>
              <InternalSuppressionItem
                name={fieldName}
                criteriaType={criteriaType}
                offers={offers}
                offerActions={offerActions}
                loadingOffers={loadingOffers}
                offerActionsLoading={offerActionsLoading}
              />
            </CardContent>
          </Card>
          {index === fields.length - 1 && (
            <Box sx={{ mt: 1 }}>
              <Tooltip title='Add Internal Pre Ping'>
                <IconButton color='success' aria-label='Add Internal Pre Ping' onClick={() => fields.push({})}>
                  <Add />
                </IconButton>
              </Tooltip>
            </Box>
          )}
        </div>
      ))}
    </div>
  );
};

export const InternalPrePings = ({ criteriaType, offers, offerActions, loadingOffers, offerActionsLoading }) => {
  return (
    <>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, lg: 6 }}>
          <Field name='internalPrePingConfiguration.andOrLogic' component={renderAndOr} type='select' />
        </Grid>
      </Grid>
      <Box sx={{ height: 400, overflowY: 'auto', mt: 1 }}>
        <FieldArray
          name='internalPrePingConfiguration.internalPrePings'
          component={renderInternalPrePings}
          criteriaType={criteriaType}
          offers={offers}
          offerActions={offerActions}
          loadingOffers={loadingOffers}
          offerActionsLoading={offerActionsLoading}
        />
      </Box>
    </>
  );
};

export default InternalPrePings;
